import { render, staticRenderFns } from "./Section5Widget.vue?vue&type=template&id=74ffc3f5&scoped=true&lang=pug&"
import script from "./Section5Widget.vue?vue&type=script&lang=js&"
export * from "./Section5Widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ffc3f5",
  null
  
)

export default component.exports